import {Box} from "@mui/material";
import {Form, FormikHelpers, FormikProvider, useFormik} from "formik";
import {IRFMContractorDataForm} from "../model/model";
import {CONTRACTOR_DATA_FORM_INITIAL_VALUE, CONTRACTOR_DATA_FORM_VALIDATION_SCHEMA} from "../utils/config";
import CurrentYearDashboardView from "../component/CurrentYearDashboardView";

// TODO: Sprint Successiva

const CurrentYearDashboardTab = (props: any) => {
    const dmsDataForm = useFormik<IRFMContractorDataForm>({
        initialValues: CONTRACTOR_DATA_FORM_INITIAL_VALUE,
        onSubmit: (values: IRFMContractorDataForm, actions: FormikHelpers<IRFMContractorDataForm>) => {

        },
        validationSchema: CONTRACTOR_DATA_FORM_VALIDATION_SCHEMA,
        validateOnChange: false,
        validateOnBlur: false
    })

    return (
        <>
            <FormikProvider value={dmsDataForm}>
                <Form>
                    <Box>
                        <CurrentYearDashboardView/>
                    </Box>
                </Form>
            </FormikProvider>
        </>
    )
}

export default CurrentYearDashboardTab;
